import { render, staticRenderFns } from "./WHIndex.vue?vue&type=template&id=55c99495&scoped=true"
import script from "./WHIndex.vue?vue&type=script&lang=js"
export * from "./WHIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c99495",
  null
  
)

export default component.exports